export const CONTACT_URL_DE = 'https://www.danceflavors.com/kontakt/?noRedirect=true';
export const CONTACT_URL_EN = 'https://www.danceflavors.com/en/contact/?noRedirect=true';
